import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';
import i18n from 'i18next';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getErrorMessageFromAPI } from '../../utilz';
import {
  deactivateRegisterEmailInError,
  deactivateRegisterEmailInSuccess,
  getRegisterEmailInError,
  getRegisterEmailInSuccess,
  registerEmailInError,
  registerEmailInSuccess,
} from './CarrierRegistrationActions';
import {
  deactivateRegisterEmailEffect,
  getRegisterEmailEffect,
  registerEmailEffect,
} from './CarrierRegistrationEffects';
import CarrierRegistrationTypes from './CarrierRegistrationTypes';

function* registerEmail({ payload }) {
  try {
    const data = yield call(registerEmailEffect, payload);
    yield put(registerEmailInSuccess({ data: data }));
    yield call(showNotification, {
      type: NOTIFICATION_TYPES.SUCCESS,
      message: i18n.t('translation:default.fields.emailCreatedSuccessfully'),
    });
  } catch (e) {
    const errorMessage = getErrorMessageFromAPI(e, i18n.t('translation:default.fields.shipmentConsolidationFailed'));
    yield put(registerEmailInError({ message: getErrorMessageFromAPI(e) }));

    yield call(showNotification, {
      type: NOTIFICATION_TYPES.ERROR,
      message: errorMessage,
    });
  }
}

function* getRegisterEmail({ payload }) {
  try {
    const { data } = yield call(getRegisterEmailEffect, payload);
    yield put(getRegisterEmailInSuccess({ data: data }));
  } catch (e) {
    yield put(getRegisterEmailInError({ message: getErrorMessageFromAPI(e) }));
  }
}

function* deactivateRegisterEmail({ payload }) {
  try {
    const { data } = yield call(deactivateRegisterEmailEffect, payload);
    if (data) {
      yield put(deactivateRegisterEmailInSuccess({}));
      yield call(showNotification, {
        type: NOTIFICATION_TYPES.SUCCESS,
        message: i18n.t('translation:default.fields.emailDeletedSuccessfully'),
      });
    }
  } catch (e) {
    const errorMessage = getErrorMessageFromAPI(e, i18n.t('translation:default.fields.shipmentConsolidationFailed'));
    yield put(deactivateRegisterEmailInError({ message: getErrorMessageFromAPI(e) }));
    yield call(showNotification, {
      type: NOTIFICATION_TYPES.ERROR,
      message: errorMessage,
    });
  }
}

export default function* carrierRegistrationdSaga() {
  yield takeLatest(CarrierRegistrationTypes.REGISTER_EMAIL_PROGRESS, registerEmail);
  yield takeLatest(CarrierRegistrationTypes.GET_REGISTER_EMAIL_PROGRESS, getRegisterEmail);
  yield takeLatest(CarrierRegistrationTypes.DEACTIVATE_REGISTER_EMAIL_PROGRESS, deactivateRegisterEmail);
}
